import { cn } from '@/lib/utils';
import {
	PRONTUARIO_PATIENT_DIVIDER_CLASS,
	PRONTUARIO_PATIENT_META_LABEL_CLASS,
	PRONTUARIO_PATIENT_TAG_CLASS,
} from '../../constants/prontuarioTheme';
import type { ProntuarioPatientHeader } from '../../utils/resolveProntuarioPatientHeader';

const PatientMetaItem = ({
	label,
	value,
}: {
	label: string;
	value: string;
}) => (
	<div className="min-w-0">
		<p className={PRONTUARIO_PATIENT_META_LABEL_CLASS}>{label}</p>
		<p className="mt-1 truncate text-[13px] leading-snug text-slate-400">
			{value}
		</p>
	</div>
);

type SessionCallProntuarioPatientSummaryProps = {
	header: ProntuarioPatientHeader;
	trailing?: React.ReactNode;
	className?: string;
};

const SessionCallProntuarioPatientSummary = ({
	header,
	trailing,
	className,
}: SessionCallProntuarioPatientSummaryProps) => (
	<div className={cn('min-w-0', className)}>
		<div className="flex items-center gap-3">
			<div
				className="flex size-10 shrink-0 items-center justify-center rounded-full bg-white/[0.08] text-[13px] font-medium uppercase tracking-wide text-slate-300"
				aria-hidden
			>
				{header.initials}
			</div>

			<div className="min-w-0 flex-1">
				<p
					className="truncate text-[15px] font-medium leading-tight tracking-tight text-slate-100"
					title={header.fullName}
				>
					{header.fullName}
				</p>
				<p className="mt-0.5 truncate text-[13px] leading-snug text-slate-500">
					{header.ageLabel} · Sessão {header.sessionNumber}
				</p>
			</div>

			{trailing}
		</div>

		<div
			className={cn(
				'mt-3 grid grid-cols-2 gap-3 pt-3',
				PRONTUARIO_PATIENT_DIVIDER_CLASS,
			)}
		>
			<PatientMetaItem label="Início" value={header.firstSessionDate} />
			{header.frequency ? (
				<PatientMetaItem label="Frequência" value={header.frequency} />
			) : null}
		</div>

		{header.tags.length > 0 ? (
			<div className={cn('mt-3 pt-3', PRONTUARIO_PATIENT_DIVIDER_CLASS)}>
				<p className={PRONTUARIO_PATIENT_META_LABEL_CLASS}>
					Evolução clínica
				</p>
				<div className="mt-2 flex flex-wrap gap-1.5">
					{header.tags.map((tag) => (
						<span
							key={tag}
							className={PRONTUARIO_PATIENT_TAG_CLASS}
						>
							{tag}
						</span>
					))}
				</div>
			</div>
		) : null}
	</div>
);

export { SessionCallProntuarioPatientSummary };
